<button
  trackable="Edit delivery/{{ trackableText }}/Contact us button"
  (click)="onClick()"
  [style.--brand-color]="brandColor">
  <span>Contact us</span>
</button>
